
import { combineReducers } from 'redux';
import apiService from '../reducer/apiService';



const appReducer = combineReducers({
    apiService,

})
// const rootReducer = combineReducers({
//     ...Reducers
// });
const rootReducer = (state, action) => {
    if (action.type === 'LOGOUT') {
        state = undefined; // Reset the entire state
        
        // Preserve remembered email during logout
        const rememberedCredentials = localStorage.getItem('rememberedCredentials');
        console.log('Logout: Preserving remembered email:', rememberedCredentials ? 'Yes' : 'No');
        localStorage.clear();
        sessionStorage.clear();
        
        // Restore remembered email if it exists
        if (rememberedCredentials) {
            localStorage.setItem('rememberedCredentials', rememberedCredentials);
            console.log('Logout: Restored remembered email');
        }
    }
    return appReducer(state, action);
};
export default rootReducer;